module.exports = __webpack_public_path__ + "static/media/kitchen.ec66a8a8.svg";